<div class="p-32">
    <ng-container>
        <app-platform-user-access-management-header
            (onPayloadUpdate)="onPayloadUpdate($event)"
            [headerTemplate]="headerTemplate"
            [uamConfig]="uamConfig"
        >
        </app-platform-user-access-management-header>
    </ng-container>

    <div class="w-100-p overflow-x" fusePerfectScrollbar>
        <app-data-table
            class="primary"
            (onFetchDataRequired)="fetchDataRequired($event)"
            (onSelectData)="selectData($event)"
            [datatableModelInput]="datatableModel"
        >
        </app-data-table>
    </div>
</div>
